import { render, staticRenderFns } from "./TabDialog.vue?vue&type=template&id=ae53b43c&scoped=true&"
import script from "./TabDialog.vue?vue&type=script&lang=js&"
export * from "./TabDialog.vue?vue&type=script&lang=js&"
import style0 from "./TabDialog.vue?vue&type=style&index=0&id=ae53b43c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae53b43c",
  null
  
)

export default component.exports